<template>
  <div class="app" id="app">
    <TopBar />
    <div class="bg">
      <router-view />
    </div>
    <Footer v-if="isRouterAlive" v />
  </div>
</template>
<script>
import TopBar from './components/TopBar'
import Footer from './components/Footer'
export default {
  components: { TopBar, Footer },
  data() {
    return {
      isRouterAlive: true
    }
  },
  //监听器
  watch: {
    // 方法1
    $route: {
      //监听路由是否变化
      handler: function (val, oldVal) {
        this.isRouterAlive = false
        this.$nextTick(function () {
          //页面加载完成后执行
          var that = this
          setTimeout(() => {
            that.reload()
          }, 200)
        })
      },
      // 深度观察监听
      deep: true
    }
  },
  mounted() {
    let type = window.localStorage.getItem('language')

    if (!type) {
      window.localStorage.setItem('language', 'e')
    }
    if (type == 'z') {
      window.localStorage.setItem('language', 'f')
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
  outline: 0;
  -webkit-text-size-adjust: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-appearance: none;
  /*消除输入框和按钮的原生外观*/
  font-family: '\5FAE\8F6F\96C5\9ED1';
}
.app {
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}

//响应式示例写法
@media screen and (max-width: 800px) {
  //手机尺寸
  .bg {
    width: 100%;
    font-family: Oswald-Bold; //设置字体，具体名称看Font/Oswald/oswald.css文件
  }
}
@media screen and (min-width: 801px) {
  //大于手机使用
  .bg {
    width: 100%;
  }
}
</style>
